import Vue       from 'vue'
import Router    from 'vue-router'
import axios     from 'axios'
import VueAxios  from 'vue-axios'
import ViewLogin from '@/views/view_login'

Vue.use(Router)
Vue.use(VueAxios, axios)
Vue.use(require('@websanova/vue-upload'))
Vue.axios.defaults.baseURL = process.env.API_ROUTE

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'login',
      component: ViewLogin
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/not_logged.js